export const filterByValue = (array: any[], value: string): any[] => {
  if (!Array.isArray(array) || array.length === 0) {
    return [];
  }
  const lowerCaseValue = value.toLowerCase();
  return array.filter((item) => {
    const matchesSearch =
      lowerCaseValue.trim() === '' ||
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(lowerCaseValue),
      );
    return matchesSearch;
  });
};
